<template>
  <div class="nav">
    <template>
      <el-checkbox-group v-model="checkboxStatusTags" size="small">
        <el-checkbox-button v-for="statusTag in statusTags" :key="statusTag.id" :label="statusTag.name"
             @touchstart.native.prevent="statusChange(statusTag)"  @click.native.prevent="statusChange(statusTag)"></el-checkbox-button>
      </el-checkbox-group>
      <el-checkbox-group v-model="checkboxDeviceTags" size="small" style="margin-left: 20px;">
        <el-checkbox-button v-for="tags in deviceTags" :key="tags.id" :label="tags.name"
            @touchstart.native.prevent="tagsChange(tags)"    @click.native.prevent="tagsChange(tags)"></el-checkbox-button>
      </el-checkbox-group>
    </template>
    <span @touchstart="showDialog()" @click="showDialog()" class="unbound-devices text-danger"
          style="margin-left: 20px;height: 28px;line-height: 25px;">
      <span>未绑定空间设备:</span>
      <span class="size">{{ unboundDevices.length }}</span>
    </span>
    <span style="margin-left: auto">
      <el-radio-group v-model="deviceViewTags" @change="statusChangeView" size="small">
        <el-radio-button label="1"><img src="@/assets/images/icon/deviceModel.png"/></el-radio-button>
        <el-radio-button label="2"><img src="@/assets/images/icon/deviceTable.png"/></el-radio-button>
      </el-radio-group>
    </span>
    <dialog-component
      :dialogVisible.sync="dialogVisible"
      @dialogClose="(data) => this.dialogVisible = data"
      dialog-title="设备绑定"
      width="80%">
      <div slot="content" style="padding: 10px 30px;height: 80vh">
        <BoundDevice :unboundDevice.sync="unboundDevices" @close="close"></BoundDevice>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import {getListByParentCode} from '@/network/extension';
import DialogComponent from "@/components/DialogComponent";
import BoundDevice from "@/views/basic_operations/device_management/device_manager/comp/BoundDevice";
import {getUnboundDevices} from "@/network/device-info";

export default {
  name: "NavBar",
  props: ["deviceTag", "status","DeviceStatusTags"],
  inject: ['reload'],
  components: {DialogComponent, BoundDevice},
  data() {
    return {
      checkboxDeviceTags: ['全部'],
      checkboxStatusTags: ['全部'],
      deviceTags: [{
        id: '',
        name: '全部'
      }], statusTags: [{
        id: '',
        name: '全部'
      }, {
        id: '0',
        name: '正常'
      }, {
        id: '1',
        name: '异常'
      }],
      dialogVisible: false,
      unboundDevices: [],
      // 视图值
      deviceViewTags:''
    }
  },
  created() {
    this.getUnboundDevices();
    this.getTags();
  },
  mounted() {
    this.deviceViewTags=this.$props.DeviceStatusTags
  },
  watch: {
    deviceTag(newVal) {
      this.deviceTag = newVal;
    },
    status(newVal) {
      this.status = newVal;
    },

  },
  methods: {
    getUnboundDevices() {
      getUnboundDevices().then(res => {
        if ( res.code === 0 ) {
          this.unboundDevices = res.data;
        }
      })
    },
    // 获取设备标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if ( res.code === 0 ) {
          res.data = res.data.filter(item => item.isDisplay);
          this.deviceTags = this.deviceTags.concat(res.data);
        }
      })
    },
    tagsChange(val) {
      this.checkboxDeviceTags = [val.name];
      this.$emit('tagsChange', val.id);
    },
    statusChange(val) {
      this.checkboxStatusTags = [val.name];
      console.log(val);
      this.$emit('statusChange', val.id);
      // this.$emit('getDeviceList');
    },
    showDialog() {
      this.dialogVisible = true;
    },
    statusChangeView(newVal){
      this.$emit('deviceStatusChange',newVal)
    },
    close() {
      this.dialogVisible = false;
      this.reload();
    }
  },
}
</script>

<style scoped>
.active {
  color: #07E6F8;
}

.nav {
  width: 100%;
}

.nav .status, .topology, .type {
  margin: 5px;
}

.nav .status span, .type span, .topology span {
  padding: 3px 12px 3px 12px;
  margin: 1px;
  background: rgba(41, 155, 255, 0.5);
  border-radius: 2px;
}

/*空间编辑*/
.nav .space-control {
  margin: 5px;
}

.nav .space-control span {
  padding: 3px 12px 3px 12px;
  margin: 1px;
  background: rgba(41, 155, 255, 0.5);
  opacity: 0.8;
  border-radius: 17px;
}

/*绑定空间*/
.nav .unbound-devices {
  margin: 3px;
  padding: 2px 12px 2px 12px;
  background: rgba(41, 159, 251, 0.2);
  border-radius: 17px;
}

.status span, .type span, .unbound-devices span, .topology span:hover {
  cursor: pointer;
}

</style>
